import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-journal',
  templateUrl: './investment-journal.component.html',
  styleUrl: './investment-journal.component.scss'
})
export class InvestmentJournalComponent {

}
